import { Modal } from 'bootstrap';
import Swal from "sweetalert2";
import { Genesis } from '../GenesisExport';
import { ISiteMobileAssetSearchAssetPage } from './ISiteMobileAssetSearchAssetPage';
const GenesisURL = require("../Genesis.js")

export class ISiteMobileAssetViewAssetDetailPage {
    private qrCode: kendo.dataviz.ui.QRCode | null = null;
    private readonly QRCodeModal = document.getElementById("modal-printQRCode");
    private readonly createSRConfirmModal = document.getElementById("modal-createSR");
    private readonly decommissionModal = document.getElementById("commentModal");
    private readonly idPrintQRCode = $("#idPrintQRCode");
    private readonly idPrintContent = $("#idPrintContent");
    private readonly btnCreateSRConfirm = $("#idCreateSR");
    private readonly btnSubmitConfirm = $("#verificationbtn");
    private readonly btnDecommissionConfirm = $("#submitDecommissionbtn");
    private readonly checkdecommissioned = $("#decommissioned");
    private readonly btnCancel = $("#cancelbtn");

    
    private readonly btnMarkAsTagged = $("#idMarkAsTagged");

    private modal: Modal | null = null;
    private modalCreateSR: Modal | null = null;
    private modalDecommission: Modal | null = null;

    constructor() {
        if (this.QRCodeModal !== null) {
            this.modal = new Modal(this.QRCodeModal, { backdrop: 'static', keyboard: false });
        }
        if (this.createSRConfirmModal !== null) {
            this.modalCreateSR = new Modal(this.createSRConfirmModal, { backdrop: 'static', keyboard: false });
        }
        if (this.decommissionModal !== null) {
            this.modalDecommission = new Modal(this.decommissionModal, { backdrop: 'static', keyboard: false });
        }
    }

    public Init() {
        var that = this;

        this.idPrintQRCode.click(function () {
            that.UpdateQRCodeText();
        });

        this.btnCreateSRConfirm.click(function () {
            var assetId = $("#RecordID").val();
            window.location.href = GenesisURL.url('/ServiceRequest/CreateSRFromAsset?assetId=' + assetId);
        });

        this.btnSubmitConfirm.click(function () {
            const id = $(this).data("id");
            that.handleVerificationSubmit(id);
        });

        this.btnCancel.click(function () {
            const id = $(this).data("id");
            that.handleCancel(id);
        });

        this.btnDecommissionConfirm.click(function () {
            const id = $("#RecordID").val() as number;
            var comments = $("#decommissioncomments").val() as string;
            if (!id || !comments || comments.trim() === "") {
                $("#comments-error").text("Comment is required.").show();
                return;
            }
            else {
                $("#comments-error").hide();
            }
            that.handleDecommissionSubmit(id, comments);
        });

        this.checkdecommissioned.click(function () {
            if ($(this).is(':checked')) {
                const recordNotesModal = document.getElementById('commentModal');
                $("#comments-error").hide();
                if (recordNotesModal !== null) {
                    that.modal = new Modal(recordNotesModal, { backdrop: false, keyboard: false });
                    that.modal.show();
                }
            }
        });

        this.btnMarkAsTagged.click(function (e) {
            e.preventDefault();
            that.MarkAssetAsTagged();
        });

        this.idPrintContent.click(function () {
            const divToPrint = document.getElementById('QRCodeDetail');
            const newWin = window.open('', 'Print-Window');
            newWin?.document.open();
            newWin?.document.write(
                '<body onload="window.print()">' +
                divToPrint?.innerHTML +
                '</body>'
            );
            newWin?.document.close();
        });
    }

    private MarkAssetAsTagged() {
        const recordId = $("#RecordID").val();
        if (!recordId) {
            return;
        }

        Swal.fire({
            title: 'Mark asset as tagged?',
            text: 'This will set Date Last Tagged to the current date and time.',
            showCancelButton: true,
            confirmButtonText: 'Yes, mark tagged',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (!result.isConfirmed) {
                return;
            }

            $.post(GenesisURL.url('/Asset/MarkAssetAsTagged'), { recordId: recordId })
                .done((response: any) => {
                    if (response && response.success) {
                        $("#DateLastTagged").val(response.dateLastTagged ?? '');
                        $("#dateLastTaggedValue").text(response.dateLastTaggedDisplay ?? '');
                        Swal.fire("Success", "Asset has been marked as tagged.", "success");
                    } else {
                        Swal.fire("Failed", response?.message ?? "Unable to mark asset as tagged.", "error");
                    }
                })
                .fail(() => {
                    Swal.fire("Failed", "There was an error marking the asset as tagged. Please try again.", "error");
                });
        });
    }

    private UpdateQRCodeText() {
        var that = this;
        $.get(GenesisURL.url('/Asset/GetAssetUDF'), {
            RecordID: $("#RecordID").val()
        }, function (responseResult) {
            that.modal?.show();
            const qrCodeElement = document.getElementById("qrcode");
            const qrCodeText: string = $("#QRCodeLink").val() as string;
            if (responseResult != null) {
                $("#lblAgressoValue").html(responseResult.externalCodeDetail);
                $("#lblOrgRetail").html(responseResult.qrCodeLabel);
            }
            if (qrCodeElement) {
                $("#qrcode").html("");
                that.qrCode = new kendo.dataviz.ui.QRCode(qrCodeElement, {
                    value: qrCodeText,
                    size: 128,
                    color: "#000",
                    background: "#fff",
                    border: { width: 0 },
                });
            } else {
                console.error("QR Code element not found.");
            }
        });
    }

    public handleVerificationSubmit(id: number): void {
        $.ajax({
            type: "POST",
            url: "VerificationSubmit",
            dataType: "json",
            data: { Id: id },
            success: function () {
                Swal.fire({ text: `Submitted Successfully` });
                window.location.reload();
            }
        });
    }

    public handleCancel(id: number): void {
        $.ajax({
            type: "POST",
            url: "CancelSubmission",
            dataType: "json",
            data: { Id: id },
            success: function () {
                Swal.fire({ text: `Cancelled Successfully` });
                const assetPage = new ISiteMobileAssetSearchAssetPage();
                assetPage.SearchVerificationAsset();
            }
        });
    }

    public handleDecommissionSubmit(id: number, comments: string): void {
        const self = this;
        $.ajax({
            type: "POST",
            url: "DecommissionSubmit",
            dataType: "json",
            data: { Id: id,Comments : comments },
            success: function () {
                Swal.fire({ text: `Submitted Successfully` });
                window.location.href = GenesisURL.url('Asset/SearchAsset?IsAssetVerification=true');
            }
        });
    }
}